/**
 * TODO: Refactoring necessary.
 *
 * - Can't we use a single hook for both cases?
 * - Do we really want recoil stuff in the nextapp package?
 * - Remove any!
 */
import { useCallback, useEffect } from 'react';
import { useRecoilState } from 'recoil';
import { getQueryStringArrayValues, getQueryStringValue, } from '@zurich/common/types';
import { useRemoveQueryStringValue, useSetQueryStringValue, } from './useNextAppQueryString';
/**
 * Synchronizes a recoil state with a query string value
 */
export function useRecoilQueryString({ key, recoilState, }) {
    const [value, setValue] = useRecoilState(recoilState);
    const setQueryStringValue = useSetQueryStringValue();
    const removeQueryStringValue = useRemoveQueryStringValue();
    // set initial state of query string to recoil state
    useEffect(() => {
        // we have to trust that the query strings are properly typed here
        // TODO: maybe add some additional checks
        const initialValue = getQueryStringValue(key);
        // this is a bit of a hack to get the values to be typed correctly
        // when they are converted from the URL string back into type T
        if (initialValue === 'true')
            setValue(true);
        else if (initialValue === 'false')
            setValue(false);
        else if (initialValue !== '' && initialValue !== null) {
            // do not set any value if empty or null, we use the default value from recoil here
            setValue(initialValue);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const onSetValue = useCallback((newValue) => {
        setValue(newValue);
        if (newValue === '' || newValue === null) {
            removeQueryStringValue(key);
        }
        else {
            setQueryStringValue(key, String(newValue));
        }
    }, 
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [key]);
    return [value, onSetValue];
}
// Gets written to query string as {key}{index} e.g. filter[arrayKey][0], filter[arrayKey][1], ...
// and keeps the value in sync with the array and recoil selector/atom
export function useRecoilArrayQueryString({ key, recoilState, }) {
    const [values, setValues] = useRecoilState(recoilState);
    const setQueryStringValue = useSetQueryStringValue();
    const removeQueryStringValue = useRemoveQueryStringValue();
    // set initial state of query string to recoil state
    useEffect(() => {
        // we have to trust that the query strings are properly typed here
        // TODO: maybe add some additional checks
        const initialValue = getQueryStringArrayValues(key);
        // do not set any value if empty or null, we use the default value from recoil here
        if (initialValue.length !== 0) {
            setValues(initialValue);
        }
    }, []);
    const onSetValues = useCallback((newValues) => {
        setValues(newValues);
        const currentValue = getQueryStringArrayValues(key);
        // reset entries before re-indexed write
        currentValue.forEach((v, i) => removeQueryStringValue(`${key}[${i}]`));
        newValues.forEach((v, i) => setQueryStringValue(`${key}[${i}]`, String(v)));
    }, [key, removeQueryStringValue, setQueryStringValue, setValues]);
    return [values, onSetValues];
}
